import { api } from '@/api';

export interface MatterDocumentUploadNode {
  documentName: string;
  documentSizeMb: number;
  documentFormat: string;
}

export interface PostMatterDocumentBulkCreateRequest {
  matterId: string;
  documents: MatterDocumentUploadNode[];
}

export interface MatterBulkCreatedDocument {
  fletchDocumentId: string;
  documentName: string;
}

export interface PostMatterDocumentBulkCreateResponse {
  documents: MatterBulkCreatedDocument[];
}

const matterDocumentBulkCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterDocumentBulkCreate: builder.mutation<
      PostMatterDocumentBulkCreateResponse,
      PostMatterDocumentBulkCreateRequest
    >({
      query: (body) => ({
        url: '/matter/document-upload/bulk-create',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostMatterDocumentBulkCreateMutation } = matterDocumentBulkCreateApi;
